import { HOUSE_KEEPING_ROOT_ENDPOINT } from './RootEndpoint';

/**
 * HouseKeeping room state report
 */
export const HOUSE_KEEPING_ROOM_STATE_REPORT = `${HOUSE_KEEPING_ROOT_ENDPOINT}/room-state-report`;
export const HOUSE_KEEPING_GET_ROOM_DETAILS = `${HOUSE_KEEPING_ROOT_ENDPOINT}/room/%d`;
export const HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL = `${HOUSE_KEEPING_ROOM_STATE_REPORT}`;
export const HOUSE_KEEPING_ROOM_STATE_REPORT_UPDATE = `${HOUSE_KEEPING_ROOM_STATE_REPORT}/room-control`;

/**
 * HouseKeeping room service status report
 */
export const HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS = `${HOUSE_KEEPING_ROOT_ENDPOINT}/room-service`;
export const HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_ROOM_DETAILS = `${HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS}/room/%d`;
export const HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_GET_ALL = `${HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS}`;
export const HOUSE_KEEPING_GET_ROOM_SERVICE_STATUS_EXPORT = `${HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS}/export`;
export const HOUSE_KEEPING_REINSTATE_ROOM_SERVICE_STATUS = `${HOUSE_KEEPING_UPDATE_ROOM_SERVICE_STATUS}/reinstate`;
export const HOUSE_KEEPING_UPDATE_ROOM_HOUSE_KEEPING_STATUS = `${HOUSE_KEEPING_ROOT_ENDPOINT}/room-housekeeping`;
